export default __webpack_public_path__ + "static/media/spinner.f60e6819.gif";